import React, {useState} from 'react';
import PropTypes from 'prop-types';

//MUI
import Grid from '@mui/material/Grid';
import ReportCard from 'components/report-card';
import {Alert, Typography} from '@mui/material';

//REDUX
import {connect} from 'react-redux';
import {rightsSelector} from 'redux/slices/appSlice';

import {REPORTS_COMPONENT_TEST_ID} from 'testidConstants';
import {reportsDefinitions} from 'components/report-card/reportsDefinitions';

const Reports = ({rights}) => {
  const [alertIsShown, setAlertIsShown] = useState(!rights.reports);

  return (
    <Grid container justifyContent="center" data-testid={REPORTS_COMPONENT_TEST_ID}>
      {alertIsShown && (
        <Alert
          sx={{width: '100%', marginTop: '8px'}}
          severity="info"
          onClose={() => {
            setAlertIsShown(false);
          }}
        >
          <Typography>You are not allowed to download reports. Please contact an administrator.</Typography>
        </Alert>
      )}

      {reportsDefinitions.map((item, index) => (
        <ReportCard report={item} key={index} />
      ))}
    </Grid>
  );
};
Reports.propTypes = {
  rights: PropTypes.object
};

const mapStateToProps = (state) => ({
  rights: rightsSelector(state)
});

export default connect(mapStateToProps)(Reports);
